import { objectSpread2 as _objectSpread2, defineProperty as _defineProperty, objectWithoutProperties as _objectWithoutProperties, toPropertyKey as _toPropertyKey, typeof as _typeof } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { PropagateUpdatesMethod } from './constants.js';

var _excluded = ["children", "passThruProps", "previousChange", "propagateUpdates"],
    _excluded2 = ["children", "passThruProps", "parentValue", "formValue", "formState", "previousChange", "previousFormChange", "propagateUpdates"];

var filterProps = function filterProps(props, filterArray) {
  return Object.keys(props).filter(function (p) {
    return filterArray.includes(p);
  }).reduce(function (acc, p) {
    return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, p, props[p]));
  }, {});
};

var omitProps = function omitProps(props, filterArray) {
  return filterArray.reduce(function (acc, p) {
    acc[p];

    var filtered = _objectWithoutProperties(acc, [p].map(_toPropertyKey));

    return filtered;
  }, _objectSpread2({}, props));
};

var fieldErrors = function fieldErrors(errors) {
  var showErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var allErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!showErrors || !errors || !errors.length) return [];
  return allErrors ? errors : [errors[0]];
};

var countErrors = function countErrors(errors) {
  return Object.values(errors).reduce(function (total, e) {
    if (Array.isArray(e) && _typeof(e[0]) === "object") return total + e.reduce(function (subtotal, f) {
      return subtotal + countErrors(f);
    }, 0);
    if (Array.isArray(e)) return total + e.length;
    if (_typeof(e) === "object") return total + countErrors(e);
    return total;
  }, 0);
};

var shallowCompareObjects = function shallowCompareObjects(a, b) {
  for (var key in a) {
    if (!(key in b) || a[key] !== b[key]) return false;
  }

  for (var _key in b) {
    if (!(_key in a) || a[_key] !== b[_key]) return false;
  }

  return true;
};

var shallowCompareArrays = function shallowCompareArrays(a, b) {
  if (a.length !== b.length) {
    return false;
  }

  for (var i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }

  return true;
};

var shouldFieldUpdate = function shouldFieldUpdate(currentProps, nextProps, propagateUpdates) {
  var currentPropagate = propagateUpdates !== null && propagateUpdates !== void 0 ? propagateUpdates : currentProps === null || currentProps === void 0 ? void 0 : currentProps.propagateUpdates;
  var nextPropagate = propagateUpdates !== null && propagateUpdates !== void 0 ? propagateUpdates : nextProps === null || nextProps === void 0 ? void 0 : nextProps.propagateUpdates;

  if (currentPropagate === PropagateUpdatesMethod.Always) {
    return true;
  }

  if (currentPropagate !== nextPropagate && Array.isArray(currentPropagate) && Array.isArray(nextPropagate)) {
    // compare dependency array values
    if (currentPropagate.length !== nextPropagate.length || currentPropagate.some(function (v, i) {
      return v !== nextPropagate[i];
    })) {
      return true;
    }
  }

  var propagateParent = currentPropagate === PropagateUpdatesMethod.Parent || currentPropagate === true; // update on props change

  var removeChildrenProp = function removeChildrenProp(props) {
    if (propagateParent) {
      var _ref = props || {};

      _ref.children;
      _ref.passThruProps;
      _ref.previousChange;
      _ref.propagateUpdates;

      var _rest = _objectWithoutProperties(_ref, _excluded);

      return _rest;
    }

    var _ref2 = props || {};

    _ref2.children;
    _ref2.passThruProps;
    _ref2.parentValue;
    _ref2.formValue;
    _ref2.formState;
    _ref2.previousChange;
    _ref2.previousFormChange;
    _ref2.propagateUpdates;

    var rest = _objectWithoutProperties(_ref2, _excluded2);

    return rest;
  };

  var currentPropsToCompare = removeChildrenProp(currentProps);
  var nextPropsToCompare = removeChildrenProp(nextProps);
  return !shallowCompareObjects(currentPropsToCompare, nextPropsToCompare);
};

var fieldFormState = function fieldFormState(context) {
  var value = context.value,
      errors = context.errors,
      parentValue = context.parentValue,
      formValue = context.formValue,
      arrayIndex = context.arrayIndex,
      disabled = context.disabled,
      readOnly = context.readOnly;
  return {
    fields: value,
    errors: errors,
    parentFields: parentValue,
    formFields: formValue,
    arrayIndex: arrayIndex,
    disabled: disabled,
    readOnly: readOnly
  };
};

var prettifyField = function prettifyField(field) {
  return field.replace(/([A-Z])/g, " $1").replace(/^./, function (c) {
    return c.toUpperCase();
  });
};

var isValueSet = function isValueSet(value) {
  return value !== undefined && value !== null && (!Array.isArray(value) || value.length > 0) && (_typeof(value) !== "object" || Object.values(value).some(function (el) {
    return isValueSet(el);
  })) && (typeof value !== "string" || value.trim() !== "");
};

export { countErrors, fieldErrors, fieldFormState, filterProps, isValueSet, omitProps, prettifyField, shallowCompareArrays, shallowCompareObjects, shouldFieldUpdate };
